
class ProductGridPagination extends HTMLElement {
    constructor() {
      super();
      this.productGrid = document.getElementById('product-grid');
      if (!this.productGrid) {
        return;
      }
      this.allItems = [...this.productGrid.children];
      this.currentPage = 1;
      this.itemsPerPage = 12;
    }
  
    connectedCallback() {
      if (!this.productGrid || this.allItems.length === 0) return;
      this.render();
      this.renderProductPage();
    }
  
    generatePageLinks() {
      const totalPages = Math.ceil(this.allItems.length / this.itemsPerPage);
     
  
      let linksHtml = '';
      const pagesToShow = [];
  
      pagesToShow.push(1);
      if (this.currentPage > 3) {
        pagesToShow.push('...');
      }
      for (let i = Math.max(2, this.currentPage - 1); i <= Math.min(totalPages - 1, this.currentPage + 1); i++) {
        pagesToShow.push(i);
      }
      if (this.currentPage < totalPages - 2) {
        pagesToShow.push('...');
      }
      pagesToShow.push(totalPages);
  
      const uniquePages = [...new Set(pagesToShow)];
  
      uniquePages.forEach(page => {
        if (page === '...') {
          linksHtml += `<span class="pagination-custom__page pagination-custom__page--ellipsis">...</span>`;
        } else if (page === this.currentPage) {
          linksHtml += `<span class="pagination-custom__page pagination-custom__page--current">${page}</span>`;
        } else {
          linksHtml += `<button class="pagination-custom__page" data-page="${page}">${page}</button>`;
        }
      });
  
      return linksHtml;
    }
  
    render() {
      const totalPages = Math.ceil(this.allItems.length / this.itemsPerPage);
      
      this.style.display = 'block';
      this.innerHTML = `
        <style>
        
            .pagination-custom {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                background-color: #ffffff;
                padding-top: 32px;
                padding-inline: 16px;
            }

            .pagination-custom__pages {
                display: flex;
                gap: 6.563px;
                align-items: center;
            }

            .pagination-custom__page {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 48px;
                height: 48px;
                border-radius: 48px;
                font-family: 'Instrument Sans', sans-serif;
                font-weight: 500;
                font-size: 16px;
                line-height: 22px;
                text-decoration: none;
                border: 1px solid rgba(30, 30, 30, 0.2);
                background-color: #ffffff;
                color: #1e1e1e;
                transition: all 0.2s ease;
                cursor: pointer;
            }

            .pagination-custom__page:hover {
                background-color: #f5f5f5;
                color: #1e1e1e;
            }

            .pagination-custom__page--current {
                background-color: #1e1e1e;
                color: #ffffff;
                border: 1px solid #1e1e1e;
                cursor: default;
            }

            .pagination-custom__page--ellipsis {
                border: none;
                cursor: default;
            }

            .pagination-custom__controls {
                position: relative;
                display: flex;
                gap: 10px;
                align-items: center;
            }

            .pagination-custom__label {
                font-family: 'Radio Canada', sans-serif;
                font-weight: 500;
                font-size: 14px;
                line-height: 20px;
                color: #1e1e1e;
            }

            .pagination-custom__label--light {
                font-weight: 300;
            }

            .pagination-custom__dropdown {
                display: flex;
                align-items: center;
                gap: 24px;
                padding: 12px 16px 12px 24px;
                background-color: #ffffff;
                border: 1px solid rgba(30, 30, 30, 0.2);
                border-radius: 48px;
                cursor: pointer;
            }

            .pagination-custom__dropdown-value {
                font-family: 'Instrument Sans', sans-serif;
                font-weight: 500;
                font-size: 16px;
                line-height: 22px;
                color: #1e1e1e;
            }

            .pagination-custom__dropdown-icon {
                width: 24px;
                height: 24px;
                flex-shrink: 0;
            }

            .pagination-custom__select {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                opacity: 0;
                cursor: pointer;
            }
            
            @media screen and (max-width: 500px) {
                .pagination-custom__controls {
                    display: none;
                }
                .pagination-custom{
                    justify-content: center;
                }
                .pagination-custom__page{
                    width: 40px;
                    height: 40px;
                }
            }
        
        </style>
        
        <div class="pagination-custom">
          <div class="pagination-custom__pages">
            ${this.generatePageLinks()}
          </div>
  
          <div class="pagination-custom__controls">
            <span class="pagination-custom__label">Show</span>
            <div class="pagination-custom__dropdown">
              <span class="pagination-custom__dropdown-value">${this.itemsPerPage}</span>
              <svg class="pagination-custom__dropdown-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M7 10L12 15L17 10" stroke="#1E1E1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <span class="pagination-custom__label pagination-custom__label--light">per page</span>
            
            <select id="items-per-page-select" class="pagination-custom__select">
              <option value="12" ${this.itemsPerPage === 12 ? 'selected' : ''}>12</option>
              <option value="20" ${this.itemsPerPage === 20 ? 'selected' : ''}>20</option>
              <option value="50" ${this.itemsPerPage === 50 ? 'selected' : ''}>50</option>
            </select>
          </div>
        </div>
      `;
  
      this.addEventListeners();
    }
  
    renderProductPage() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      const pageItems = this.allItems.slice(startIndex, endIndex);
      
      this.productGrid.innerHTML = '';
      pageItems.forEach(item => {
        this.productGrid.appendChild(item);
      });
    }
  
    addEventListeners() {
      this.querySelector('#items-per-page-select').addEventListener('change', (e) => {
        this.itemsPerPage = parseInt(e.target.value, 10);
        this.currentPage = 1;
        this.render();
        this.renderProductPage();
      });
  
      this.querySelectorAll('.pagination-custom__page[data-page]').forEach(button => {
        button.addEventListener('click', (e) => {
          this.currentPage = parseInt(e.target.dataset.page, 10);
          this.render();
          this.renderProductPage();
        });
      });
    }
  }
  
  customElements.define('product-grid-pagination', ProductGridPagination);